module.exports = __webpack_public_path__ + "media/highclass/example-5-d03a11de.webp";